import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/semantic-platform/tags/")({
  component: LegacyGlobalTagRedirect,
});

function LegacyGlobalTagRedirect() {
  return <Navigate to="/semantic-platform/data-governance/classifications" replace />;
}
